import SingleSelect from './single-select';

export default SingleSelect;
